var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-quick"},[_c('a',{attrs:{"href":_vm.$cp + 'healing'}},[_c('span',[_vm._v("힐링은평")])]),_c('a',{attrs:{"href":_vm.$cp + 'commercial'}},[_c('span',[_vm._v("상권분석")])]),_c('a',{attrs:{"href":_vm.$cp + 'indicator'}},[_c('span',[_vm._v("구정현황")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }